(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motor-product-tabs"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function() {
  $("#tab1-click").trigger("click");
  // Only append .all-content if it's not for three-phase-motors
  if (window.location.pathname !== '/products/three-phase-motors') {
    $('#tab2').append($('.all-content'));
  }
  
  // Check every 1 second if a motor has been selected
  setInterval(function() {
    updateDownloadButtons();
  }, 1000);
});

$("#tab1-click").click(function() {
  $(".tablinks").removeClass("selected");
  $(".tabcontent").hide();
  $("#tab1").show();
  $("#tab1-click").addClass("selected");
});

$("#tab2-click").click(function() {
  $(".tablinks").removeClass("selected");
  $(".tabcontent").hide();
  $("#tab2").show();
  $("#tab2-click").addClass("selected");
});

// Cache for file existence checks
let fileExistenceCache = {};

// Function to check if a file exists
function checkFileExists(url) {
  return new Promise((resolve) => {
    // Check cache first
    if (fileExistenceCache.hasOwnProperty(url)) {
      resolve(fileExistenceCache[url]);
      return;
    }
    
    const xhr = new XMLHttpRequest();
    xhr.open('HEAD', url, true);
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        const exists = xhr.status === 200;
        fileExistenceCache[url] = exists;
        resolve(exists);
      }
    };
    xhr.onerror = function() {
      fileExistenceCache[url] = false;
      resolve(false);
    };
    xhr.send();
  });
}

// Function to construct file URLs based on SKU
function constructFileURL(sku, prefix) {
  const baseURL = 'https://cdn.shopify.com/s/files/1/0783/0447/7482/files/';
  return baseURL + prefix + '-' + sku + '.pdf';
}

// Download functions - Override any existing global functions
window.downloadDatasheet = function() {
  console.log('Tab downloadDatasheet called');
  if (window.selectedMotor && window.selectedMotor.sku) {
    const datasheetURL = constructFileURL(window.selectedMotor.sku, 'DS');
    console.log('Opening datasheet URL:', datasheetURL);
    window.open(datasheetURL, '_blank');
  } else {
    alert('Please select a motor configuration first to download the datasheet.');
  }
};

window.downloadDrawing = function() {
  console.log('Tab downloadDrawing called');
  if (window.selectedMotor && window.selectedMotor.sku) {
    const drawingURL = constructFileURL(window.selectedMotor.sku, 'DG');
    console.log('Opening drawing URL:', drawingURL);
    window.open(drawingURL, '_blank');
  } else {
    alert('Please select a motor configuration first to download the drawing.');
  }
};

// Also create local versions for backup
function downloadDatasheet() {
  window.downloadDatasheet();
}

function downloadDrawing() {
  window.downloadDrawing();
}

// Update download buttons when motor is selected
async function updateDownloadButtons() {
  const datasheetBtn = document.getElementById('datasheet-btn');
  const drawingBtn = document.getElementById('drawing-btn');
  
  console.log('updateDownloadButtons called');
  console.log('window.selectedMotor:', window.selectedMotor);
  
  if (window.selectedMotor && window.selectedMotor.sku) {
    console.log('Selected motor SKU:', window.selectedMotor.sku);
    
    // Construct file URLs
    const datasheetURL = constructFileURL(window.selectedMotor.sku, 'DS');
    const drawingURL = constructFileURL(window.selectedMotor.sku, 'DG');
    
    // Check if files exist
    const [datasheetExists, drawingExists] = await Promise.all([
      checkFileExists(datasheetURL),
      checkFileExists(drawingURL)
    ]);
    
    // Update datasheet button
    if (datasheetExists) {
      datasheetBtn.disabled = false;
      datasheetBtn.textContent = 'DOWNLOAD NOW';
      console.log('Datasheet button enabled - file exists');
    } else {
      datasheetBtn.disabled = true;
      datasheetBtn.textContent = 'NOT AVAILABLE';
      console.log('Datasheet button disabled - file not found');
    }
    
    // Update drawing button
    if (drawingExists) {
      drawingBtn.disabled = false;
      drawingBtn.textContent = 'DOWNLOAD NOW';
      console.log('Drawing button enabled - file exists');
    } else {
      drawingBtn.disabled = true;
      drawingBtn.textContent = 'NOT AVAILABLE';
      console.log('Drawing button disabled - file not found');
    }
  } else {
    // No motor selected
    datasheetBtn.disabled = true;
    datasheetBtn.textContent = 'SELECT MOTOR FIRST';
    drawingBtn.disabled = true;
    drawingBtn.textContent = 'SELECT MOTOR FIRST';
    console.log('No motor selected');
  }
}

// Call this function whenever a motor is selected in the configurator
// This should be triggered from your motor configurator code
window.addEventListener('motorSelected', updateDownloadButtons);

// Initial state
updateDownloadButtons();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    


$( document ).ready(function() {
     $( "#tab1-click" ).trigger( "click" );

$('#tab2').append($('.all-content'));

});
 

  
  $("#tab1-click").click(function() {
    $(".tablinks").removeClass("selected");
    $(".tabcontent").hide();
    $("#tab1").show();
    $("#tab1-click").addClass("selected");
    
});


  $("#tab2-click").click(function() {
    $(".tablinks").removeClass("selected");
    $(".tabcontent").hide();
    $("#tab2").show();
    $("#tab2-click").addClass("selected");
    
});

    $("#tab3-click").click(function() {
    $(".tablinks").removeClass("selected");
    $(".tabcontent").hide();
    $("#tab3").show();
      $("#tab3-click").addClass("selected");
    
    
});

      $("#tab4-click").click(function() {
    $(".tablinks").removeClass("selected");
    $(".tabcontent").hide();
    $("#tab4").show();
        $("#tab4-click").addClass("selected");
    
    
});
  

  } catch(e) { console.error(e); }
})();
})();
